import { createSlice } from "@reduxjs/toolkit";
import {
  accountActivation,
  forceResetPassword,
  login,
  logout,
  registerAccount,
  resetPassword,
  sendEmailVerification,
  verifyNewPassword,
  license
} from "./actions/auth";

const initialState = {
  email: "",
  emailSuccess: false,
  isAuthenticated: false,
  loading: false,
  activationLoading: false,
  accountActivated: null,
  accountVerified: null,
  vendorUserId: null,
  flowId: null,
  resetPasswordCode: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setVerifiedEmail: (state, action) => {
      state.email = action.payload;
    },
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        const { accountState, vendorUserId } = action.payload;
        state.loading = false;
        localStorage.setItem("vendorUserId", vendorUserId);
        if (accountState === "VERIFICATION_REQUIRED") {
          state.accountVerified = accountState;
          state.vendorUserId = vendorUserId;
        } else {
          window.location.href = "/app";
        }
      })
      .addCase(login.rejected, (state, action) => {
        const errorMsg = action.payload;
        state.loading = false;
        if (errorMsg.code === "SE_36") {
          window.location.href = "/login#/license";
        }
      });

    builder
      .addCase(license.pending, (state) => {
        state.loading = true;
      })
      .addCase(license.fulfilled, (state, action) => {
        state.loading = false;
        window.location.href = "/";
      })
      .addCase(license.rejected, (state, action) => {
        const errorRes = action.payload;
        state.loading = false;
        if (errorRes.code === "SE_37") {
          window.location.href = "/login#/license";
        }
      });

    builder
      .addCase(logout.pending, (state) => {
        state.loading = true;
      })
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        window.location.href = "/";
      })
      .addCase(logout.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(forceResetPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(forceResetPassword.fulfilled, (state) => {
        state.loading = false;
        window.location.href = "/login";
      })
      .addCase(forceResetPassword.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.flowId = action.payload.flowId;
      })
      .addCase(resetPassword.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(verifyNewPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyNewPassword.fulfilled, (state, action) => {
        state.loading = false;
        window.location.href = "/login";
      })
      .addCase(verifyNewPassword.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(sendEmailVerification.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendEmailVerification.fulfilled, (state) => {
        state.loading = false;
        state.emailSuccess = true;
      })
      .addCase(sendEmailVerification.rejected, (state, action) => {
        state.loading = false;
        state.emailSuccess = false;
      });

    builder
      .addCase(accountActivation.pending, (state) => {
        state.activationLoading = true;
      })
      .addCase(accountActivation.fulfilled, (state) => {
        state.activationLoading = false;
        state.accountActivated = "success";
      })
      .addCase(accountActivation.rejected, (state) => {
        state.activationLoading = false;
        state.accountActivated = "failed";
      });

    builder
      .addCase(registerAccount.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerAccount.fulfilled, (state) => {
        state.loading = false;
        window.location.href = "/app";
      })
      .addCase(registerAccount.rejected, (state) => {
        state.loading = false;
        // window.location.href = "/app";
      });
  },
});

export const { setVerifiedEmail, setAuthenticated } = authSlice.actions;

export default authSlice.reducer;
